import { useQuery } from '@tanstack/react-query';
import { DualWriteStatsSchema } from '@shared/dual-write/stats.schema';
import { useApi } from '../../../lib/api';
import { fetchJson } from '../../../lib/apiFetchJson';

/** GET /api/v4/admin/dual-write/stats under the one shared cache key. */
export function useDualWriteStats(opts: { staleTime?: number; refetchInterval?: number } = {}) {
  const { apiFetch } = useApi();
  return useQuery({
    queryKey: ['admin', 'dual-write', 'stats'],
    queryFn: () => fetchJson(apiFetch, DualWriteStatsSchema, '/api/v4/admin/dual-write/stats'),
    ...opts,
  });
}
